module.exports = __webpack_public_path__ + "static/kartchen-kultur-gastro2-802d40e37852ebc5f1b84d82d4bf7525.png";